<ng-container *ngIf="viewModel$ | async as vm">
  <div class="row no-gutters">
    <div class="col p-1">
      <div class="row no-gutters">
        <div class="col-3 p-1">
          <button
            type="button"
            class="btn btn-secondary btn-sm btn-block"
            *ngIf="vm.available.visible"
            [disabled]="!vm.available.enabled"
            (click)="available()"
            title="{{ vm.available.hoverText }}"
          >
            <small>Avail</small>
          </button>
        </div>
        <div class="col-3 p-1">
          <button
            type="button"
            class="btn btn-secondary btn-sm btn-block"
            (click)="showVoicemailModal()"
            [disabled]="!vm.msg?.enabled"
            title="{{ vm.msg?.hoverText }}"
          >
            <small [ngStyle]="{ color: vm.msg?.enabled ? 'red' : null }"
              >Msg</small
            >
          </button>
        </div>
        <div class="col-3 p-1">
          <button
            type="button"
            class="btn btn-secondary btn-sm btn-block"
            [disabled]="!vm.tasks?.enabled"
            (click)="openTasks()"
            title="{{ vm.tasks?.hoverText }}"
          >
            <small>Tasks</small>
          </button>
        </div>
        <div class="col-3 p-1">
          <button
            type="button"
            class="btn btn-secondary btn-sm btn-block"
            [disabled]="!vm.exit?.enabled"
            (click)="exit()"
          >
            <small>Exit</small>
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-container>
